module.exports = __webpack_public_path__ + "img/math-3.56b26d2f.png";